// Steps styles

import styled from 'styled-components';
import { pseudo, media } from 'styles/utils';
import Icon from 'components/Icon';

const STEP_BORDER_WIDTH = '4px';

export const StepsStyled = styled.ul`
  display: flex;
  justify-content: space-between;
  position: relative;
  &::before,
  &::after {
    ${pseudo('absolute', '100%', STEP_BORDER_WIDTH)};
    top: 50%;
    transform: translateY(-50%);
  }
  &::before {
    background-color: ${props => props.theme.color.wfGrey300};
  }
  &::after {
    background-color: ${props => props.theme.color.primary};
    width: ${props =>
      `calc((100%/${props.totalSteps - 1}) * ${props.stepActive - 1})`};
    transition: width ease-out 0.4s;
  }
`;

export const Step = styled.li`
  width: 80px;
  text-align: center;
  /* Media queries */
  ${media.medium`
    width: 200px;
  `}
`;

export const StepContent = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  border: 1px solid
    ${props =>
      props.isActive ? props.theme.color.primary : props.theme.color.wfGrey200};
  border-radius: ${props => props.theme.borderRadius.small};
  background-color: ${props =>
    props.isValidated
      ? props.theme.color.wfWhite
      : props.isActive
      ? props.theme.color.primaryLightest
      : props.theme.color.wfGrey100};
  z-index: 5;
  color: ${props =>
    props.isActive ? props.theme.color.primary : props.theme.color.wfGrey900};
  display: inline-block;
  padding: ${props => props.theme.spacing.small};
  font-size: ${props => props.theme.font.size.xsmall};
  text-align: center;
  word-break: break-word;
`;

export const NumberStep = styled.strong`
  display: block;
`;

export const IconStyled = styled(Icon)`
  display: ${props => (props.isVisible ? 'inline-block' : 'none')};
  color: ${props => props.theme.color.wfGreen};
  vertical-align: text-top;
  margin-left: ${props => props.theme.spacing.xsmall};
`;
